import { useState } from 'react'

import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import VerifiedIcon from '@mui/icons-material/Verified'
import { Chip, Stack, Typography } from '@mui/material'
import { GeoRegion } from '@/components/forms/GeoBlockingTemplateForm'

import { RegionChip } from './RegionChip'

type Props = {
  regions: GeoRegion[]
  isWhiteList: boolean
  maxVisible?: number
}

export const CollapsibleRegionChips = ({ regions, isWhiteList, maxVisible = 2 }: Props) => {
  const [showAll, setShowAll] = useState(false)

  if (!regions.length) {
    return null
  }

  const shouldShowMore = regions.length > maxVisible + 1
  const visibleRegions = showAll ? regions : regions.slice(0, maxVisible)
  const remainingCount = regions.length - maxVisible

  return (
    <Stack
      sx={{
        flexDirection: 'column',
        alignItems: 'start',
        gap: 1,
        overflow: 'hidden',
        paddingY: 1
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        {isWhiteList ? <VerifiedIcon color="success" /> : <DoDisturbIcon color="error" />}
        <Typography fontSize={12} fontWeight="bold">
          {isWhiteList ? 'Whitelisted' : 'Blacklisted'}:
        </Typography>
      </Stack>

      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1,
          alignItems: 'start'
        }}
      >
        {visibleRegions.map((region) => (
          <RegionChip key={region.iso2} withFlag region={region} />
        ))}

        {shouldShowMore && !showAll && (
          <Chip
            label={`+${remainingCount} more`}
            size="small"
            variant="outlined"
            onClick={() => setShowAll(true)}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          />
        )}

        {showAll && shouldShowMore && (
          <Chip
            label="show less"
            size="small"
            variant="outlined"
            onClick={() => setShowAll(false)}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          />
        )}
      </Stack>
    </Stack>
  )
}
